/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M2 12L5 9M2 12L5 15M2 12H12H22M22 12L19 9M22 12L19 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 2L9 5M12 2L15 5M12 2L12 12L12 22M12 22L9 19M12 22L15 19"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2 12L12 2L22 12L12 22L2 12Z"
				fill="currentColor"
			/>
			<path
				d="M2 12L5 9M2 12L5 15M2 12H12M12 12H22M12 12V22M12 12V2M22 12L19 9M22 12L19 15M12 2L9 5M12 2L15 5M12 22L9 19M12 22L15 19"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M2 12L5 9M2 12L5 15M2 12H12M12 12H22M12 12V22M12 12V2M22 12L19 9M22 12L19 15M12 2L9 5M12 2L15 5M12 22L9 19M12 22L15 19"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M5 15L2 12H9M19 9L22 12H15M20 14L19 15M4 10L5 9M9 5L12 2V22L15 19M14 4L15 5M10 20L9 19"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 12L5 9M2 12L5 15M2 12H12M12 12H22M12 12V22M12 12V2M22 12L19 9M22 12L19 15M12 2L9 5M12 2L15 5M12 22L9 19M12 22L15 19"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M2 12L5 9M2 12L5 15M2 12H12M12 12H22M12 12V22M12 12V2M22 12L19 9M22 12L19 15M12 2L9 5M12 2L15 5M12 22L9 19M12 22L15 19"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
